import { Alert } from "flowbite-react";
import { CircleAlert } from "lucide-react";

type LoginFormErrorProps = {
  title: string | null
  description: string | null
};

export const LoginFormError = ({ title, description }: LoginFormErrorProps) => {
  if (!title || !description) return null;

  return (
    <Alert
      color="lighterror"
      icon={CircleAlert}
      className="[&>*]:items-start"
      data-testid="login-form-error"
    >
      <p className="font-bold">{title}</p>
      <p>{description}</p>
    </Alert>
  );
};
